import { ApiResponse, TicketManagerTicket } from '@vision/ui/interfaces';
import { TicketManagerApi } from '../ticket-manager.api';
import { TicketManagerPoolTicketsArgs, TicketManagerQueueTicketsArgs } from './ticket-lists.api.types';
import { normalizeTicketManagerTicketListResponse } from './ticket-lists.mappers';
import { buildPoolTicketsRequest, buildQueueTicketsRequest } from './ticket-lists.routes';

export const TicketListEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    ticketManagerPoolTickets: builder.query<ApiResponse<TicketManagerTicket[]>, TicketManagerPoolTicketsArgs>({
      query: ({ poolId, projectId, query }) => buildPoolTicketsRequest({ poolId, projectId, query }),
      transformResponse: normalizeTicketManagerTicketListResponse,
      providesTags: (_result, _error, { poolId }) => [{ type: 'TicketManagerPoolTickets', id: poolId || 'DEFAULT' }],
    }),
    ticketManagerQueueTickets: builder.query<ApiResponse<TicketManagerTicket[]>, TicketManagerQueueTicketsArgs>({
      query: ({ projectId, queueId, query }) => buildQueueTicketsRequest({ projectId, queueId, query }),
      transformResponse: normalizeTicketManagerTicketListResponse,
      providesTags: (_result, _error, { queueId }) => [{ type: 'TicketManagerQueueTickets', id: queueId || 'DEFAULT' }],
    }),
  }),
});

export const { useLazyTicketManagerPoolTicketsQuery, useLazyTicketManagerQueueTicketsQuery } = TicketListEndpoints;
